var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VList",
    { staticClass: "bucket-settings-entries-component" },
    _vm._l(_vm.routes, function(childRoute) {
      return _c(
        "VListTile",
        {
          key: childRoute.name,
          staticClass: "child-link",
          attrs: { to: { name: childRoute.name } }
        },
        [
          _c(
            "VListTileAction",
            [_c("KmIcon", { attrs: { name: childRoute.meta.icon } })],
            1
          ),
          _vm._v(" "),
          _c(
            "VListTileContent",
            [
              _c("VListTileTitle", [
                _vm._v(
                  "\n        " + _vm._s(childRoute.meta.title) + "\n      "
                )
              ])
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }